// extracted by mini-css-extract-plugin
export default {"search_result":"SearchResult_search_result__UJm27"};